import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import SplashScreen from "./components/splash";
import Welcome from "./components/Welcome";
import UserLogin from "./components/userLogin";
import StartPricing from "./components/startPricing";
import Disclaimer from "./components/disclaimer";
import PriceDataProvider from "../src/context";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Userprofile from "./components/Userprofile/Userprofile";
import AuthRoute from "./components/AuthRoute/AuthRoute";
import UserRegister from "./components/userRegister/userRegister";
import DesktopResult from "./components/result/desktopResult";
import IndexPricing from "./components/pricing/IndexPricing";
import UnAuthRoute from "./components/AuthRoute/UnAuthRoute";
import Searchhistory from "./components/SearchHistory/Searchhistory";
import axios from "axios";
import { queryString } from "./utils/queryString";
import IduEditor from "./components/IduEditor/IduEditor";
function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/start-pricing') {
      document.body.classList.add('disclaimer-active');
    } 
    else {
      document.body.classList.remove('disclaimer-active');
    }

    // Clean up on unmount
    return () => {
      document.body.classList.remove('disclaimer-active');
    };
  }, [location]);

  const userLocation = () => {
    const geolocationSuccess = async (position) => {
      try {
        const {
          coords: { latitude, longitude },
        } = position;
        let obj = null;
        if (!latitude || !longitude) {
          localStorage.setItem("curr_location", obj);
          return;
        }
        // Get the location details.
        const location1 = await axios.get(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
        );
        if (location1?.data?.address) {
          obj = {
            city: location1?.data?.address?.city,
            country: location1?.data?.address?.country,
            country_code: location1?.data?.address?.country_code,
            county: location1?.data?.address?.county,
            state_district: location1?.data?.address?.state_district,
            postcode: location1?.data?.address?.postcode,
            suburb: location1?.data?.address?.suburb,
            state: location1?.data?.address?.state,
          };
        } else {
          // Get the location details if above api don't have data.
          const location2 = await axios.get(
            `https://api.opencagedata.com/geocode/v1/json?q=${latitude},${longitude}&key=${process.env.REACT_APP_OPENCAGEKEY}`
          );
          if (
            location2?.data?.status.code === 200 &&
            location2?.data?.results &&
            location2?.data?.results.length > 0
          ) {
            const locationRes = location2?.data?.results[0]?.components;
            obj = {
              city: locationRes.city,
              country: locationRes.country,
              country_code: locationRes.country_code,
              county: locationRes.county,
              state_district: locationRes.state_district,
              postcode: locationRes.postcode,
              suburb: locationRes.suburb,
            };
          }
        }
        localStorage.setItem("curr_location", JSON.stringify(obj));
      } catch (error) {
        console.log("error", error);
        localStorage.setItem("curr_location", null);
      }
    };

    if (window.navigator) {
      window.navigator.geolocation?.getCurrentPosition(
        async (position) => {
          await geolocationSuccess(position);
        },
        (err) => {
          console.log("error in geolocation", err);
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    }
  };

  const { token , id} = queryString();
  useEffect(() => {
    //console.log("loginauth", cookie.get("loginauth"));
    if (!token && !localStorage.getItem("fcrf@token") && !id) {
      if (window.location !== window.parent.location) {
        // The page is in an iframe
      } else {
      
      }
    } else {
      
      userLocation();
    }
  }, [token, id]);

  return (
    <>
      <PriceDataProvider>
        <Routes>
          <Route path="/" element={<SplashScreen />} />
          <Route path="/welcome" element={<UnAuthRoute component={<Welcome />} />} />
          <Route path="/user-login" element={<UnAuthRoute component={<UserLogin />} />} />
          <Route
            path="/start-pricing"
            element={<StartPricing />}
          />
          <Route
            path="/disclaimer"
            element={<AuthRoute component={<Disclaimer />} />}
          />
           <Route
            path="/pricing"
            element={<AuthRoute component={<IndexPricing />} />}
          />
          <Route
            path="/result"
            element={<AuthRoute component={<DesktopResult />} />}
          />
          <Route path="/profile" element={<Userprofile />} />
          <Route path="/price-intelligence-search-history" element={<Searchhistory />} />
          <Route path="/user-register" element={<UserRegister />} />
          <Route path="/idu-editor" element={<IduEditor />} />
        </Routes>
      </PriceDataProvider>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        style={{ width: "400px" }}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
